import { MapPin, Quote, Star } from "lucide-react";
import { Card, CardContent } from "../Card";
import type { Testimonial } from "../../types/aquagym";
interface TestimonialCardProps {
  testimonial: Testimonial;
}
export function TestimonialCard({
  testimonial
}: TestimonialCardProps) {
  const initials = getInitials(testimonial.name);
  return <Card className="h-full overflow-hidden rounded-3xl border border-[#E2E8F0] bg-white shadow-[0_16px_40px_rgba(12,74,110,0.08)]" data-id="element-193" data-mp="2m1r68yxkfoq8">
      <CardContent className="relative flex h-full flex-col p-6 sm:p-8" data-id="element-194" data-mp="1odh48jxs50z4">
        <Quote className="absolute right-6 top-6 size-10 fill-[#CFFAFE] text-[#CFFAFE]" aria-hidden="true" data-id="element-195" data-mp="1tewucqetdxod" />
        <div className="flex gap-1 text-[#FACC15]" aria-label="5 de 5 estrellas" data-id="element-196" data-mp="1yc6m4cpoelfd">
          {Array.from({
          length: 5
        }, (_, index) => <Star key={index} className="size-5 fill-current" aria-hidden="true" data-id="element-197" data-mp="15p2ctvjjvkxs" />)}
        </div>
        <blockquote className="mt-5 flex-1 pr-2 text-base font-medium italic leading-7 text-[#1E293B] sm:text-lg sm:leading-8" data-id="element-198" data-mp="1andn27drbxgj">
          “{testimonial.quote}”
        </blockquote>
        <footer className="mt-7 flex items-center gap-4 border-t border-[#E2E8F0] pt-6" data-id="element-199" data-mp="366v1374ofsmi">
          <span className="flex size-14 shrink-0 items-center justify-center rounded-full bg-[#0891B2] text-lg font-black text-white shadow-[0_8px_20px_rgba(8,145,178,0.22)]" aria-hidden="true" data-id="element-200" data-mp="3697fxbf51mvc">
            {initials}
          </span>
          <div className="min-w-0 text-left" data-id="element-201" data-mp="2sfq4yf0ipigx">
            <p className="text-sm font-black text-[#0C4A6E] sm:text-base" data-id="element-202" data-mp="2sddd9a4yjtqo">{testimonial.name}</p>
            <p className="mt-0.5 flex items-center gap-1 text-xs text-[#475569] sm:text-sm" data-id="element-203" data-mp="2nig84easu4j2">
              <MapPin className="size-3.5 shrink-0 text-[#64748B]" aria-hidden="true" data-id="element-204" data-mp="2ihiqc2tpbci3" />
              {testimonial.location}
            </p>
            <p className="mt-1 text-[10px] font-bold uppercase leading-4 tracking-[0.08em] text-[#0369A1] sm:text-xs" data-id="element-205" data-mp="gpni5x6nlq4m">
              {testimonial.role}
            </p>
          </div>
        </footer>
      </CardContent>
    </Card>;
}
function getInitials(name: string) {
  return name.replace(/[^A-Za-zÁÉÍÓÚÜÑáéíóúüñ\s]/g, "").split(/\s+/).filter(Boolean).slice(0, 2).map(part => part.charAt(0).toUpperCase()).join("");
}